import spanishTexts from '../../../locale/messages.json';
import englishTexts from '../../../locale/messages-en.json';

const flattenObject = (obj: any, prefix = ''): Record<string, string> => {
  return Object.keys(obj).reduce((acc, key) => {
    const pre = prefix.length ? prefix + '.' : '';
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(acc, flattenObject(obj[key], pre + key));
    } else {
      acc[pre + key] = obj[key];
    }
    return acc;
  }, {} as Record<string, string>);
};

export const flattenedSpanishTexts = flattenObject(spanishTexts.texts);
export const flattenedEnglishTexts = flattenObject(englishTexts.texts);